import * as taskTypes from "Store/backgroundTasks/constants";

const initialState: IBackgroundTasksReducer = {
  tasks: {}
};

const backgroundTasksReducer = (state = initialState, action): IBackgroundTasksReducer => {
  switch (action.type) {
    case taskTypes.BACKGROUND_TASK_STARTED:
      return {
        ...state,
        tasks: {
          ...state.tasks,
          [action.payload.id]: {
            id: action.payload.id,
            label: action.payload.label,
            classroomId: action.payload.classroomId,
            total: action.payload.total,
            kind: action.payload.kind,
            processed: 0,
            failed: 0,
            finished: false
          }
        }
      };
    case taskTypes.BACKGROUND_TASK_PROGRESS:
    case taskTypes.BACKGROUND_TASK_FINISHED: {
      const task = state.tasks[action.payload.id];
      if (!task) return state;
      return {
        ...state,
        tasks: {
          ...state.tasks,
          [action.payload.id]: {
            ...task,
            processed: action.payload.processed,
            failed: action.payload.failed,
            total: action.payload.total,
            finished: action.type === taskTypes.BACKGROUND_TASK_FINISHED
          }
        }
      };
    }
    case taskTypes.BACKGROUND_TASK_DISMISSED: {
      const tasks = { ...state.tasks };
      delete tasks[action.payload.id];
      return { ...state, tasks };
    }
    default:
      return state;
  }
};

export default backgroundTasksReducer;
